import React from 'react';
import axios from "axios";
import configData from "../../config/config.json";
import { connect } from "react-redux";
import { Form, Container, Row, Col } from 'react-bootstrap'

import PageBanner from "../common/page/PageBanner.js";
import Alert from '../common/modal/Alert';
import TextField from "../common/form/TextField.js";
import { setSelectedTenantAdminType, AlertListTenantAdminKey } from "../../redux/actions/tenantAdminActions.js";
import { saveAlert } from "../../redux/actions/alertActions.js";
import Loading from '../common/modal/Loading.js';
import { ALERT_TYPES, LOADING_STATUES } from "../constants/constants.js";
import SecondaryButton from '../common/form/SecondaryButton.js';
import Confirmation from '../common/modal/Confirmation';

const componentName = AlertListTenantAdminKey;

const mapStateToProps = (state) => {
	return {
		sideNavigationOpen: state.sideNavigationReducer,
		alertListFilters: state.alertListFiltersReducer,
		alertSettings: state.countyConfigAlertSettingsReducer
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		setSelectedTenantAdminType: () => dispatch(setSelectedTenantAdminType(componentName)),
		saveAlert: (alert, callback) => dispatch(saveAlert(alert, callback))
	}
}

class AlertView extends React.Component {
	state = {
		id: 0,
		alertType: 'BUSINESS',
		name: '',
		firstName: '',
		lastName: '',
		businessName: '',

		alertEmailAddresses: [],
		alertPhones: [],

		parcelId: '',
		selectedEmailField: '',
		selectedPhoneField: '',
		statusType: 'A',
		showDeleteConfirmationDialog: false,
		loadingStatus: '',
		alertComponentType: ALERT_TYPES.OK,
		errors: {},
		showAlert: false,
		alertMessage: "",
		redirect: false
	}

	showLoading = () => {
		if (this.state.loadingStatus === "") {
			this.setState({
				loadingStatus: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

	hideLoading = (loadingStatus) => {
		if (loadingStatus === 'ERROR') {
			this.setState({
				loadingStatus: ""
			})
		} else {
			this.setState({
				loadingStatus: ""
			})
		}
	}

	handleCancel = (event) => {
		event.preventDefault();
		this.props.history.push('/tenantAdmin/alerts');
	}

	// Delete methods
	handleDeleteAlert = () => {
		if (this.showLoading() === true) {
			let request = {
				alertId: this.state.id,
				filterText: this.props.alertListFilters.filterText,
				includeInactive:
					this.props.alertListFilters.includeInactive
			};

			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/alertDelete", request, { withCredentials: true })
				.then((response) => {
					this.setState({ loadingStatus: "", redirect: true }, this.showAlert(response.data.message));
				}, (error) => {

					this.setState({ loadingStatus: "", redirect: false }, this.showAlert(error.response.data.message));
				});
		}
	}

	showDeleteConfirmation = (event) => {
		event.preventDefault();
		this.setState({
			showDeleteConfirmationDialog: true
		})
	}

	hideDeleteConfirmation = () => {
		this.setState({
			showDeleteConfirmationDialog: false
		})
	}
	// Delete methods - End

	showAlert = (alertMessage) => {
		this.setState({
		  showAlert: true,
		  alertMessage
		})
	  }

	showWarning = (alertMessage) => {
		this.setState({
		  alertType: ALERT_TYPES.WARNING,
		  showAlert: true,
		  alertMessage
		})
	}
	
	hideAlert = () => {
		this.setState({
			showAlert: false,
			alertMessage: "",
			alertType: ALERT_TYPES.OK
		}, this.props.history.push('/tenantAdmin/alerts'))
	}

	componentDidMount() {
		this.props.setSelectedTenantAdminType();

		axios.get(configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/alertView/" + this.props.match.params.id, { withCredentials: true })
			.then(
				(response) => {
					const content = response.data.content;
					let newState = this.getStateFromContent(content);
					this.setState(newState);
				},
				(error) => {
					console.log(error);
				}
			);
	}

	getStateFromContent = (content) => {
		return {
			id: content.id,
			alertType: content.alertType,
			name: content.name,
			firstName: content.firstName,
			lastName: content.lastName,
			businessName: content.businessName,
			parcelId: content.parcelId,
			alertEmailAddresses: content.alertEmailAddresses,
			alertPhones: content.alertPhones,
			statusType: content.statusType
		};
	}

	render() {
		let alertTypeDescription = "Parcel ID";
		if (this.state.alertType === 'BUSINESS') {
			alertTypeDescription = "Business/Trust";
		} else if (this.state.alertType === 'NAME') {
			alertTypeDescription = "Person";
		}
		let alertType = <TextField formGroup={{ id: 'alertType', label: 'Monitor', fieldType: 'text', value: alertTypeDescription, primaryCriteria: true, disableField: true }} />
		
		let pageButtons = [];

		pageButtons.push({ label: 'Delete', onClickAction: this.showDeleteConfirmation, className: 'btn btn-danger btn-sm' });

		let formTemplateMarginLeft = 60
		let formTemplateMarginRight = 20
		if (this.props.formOnly) {
			formTemplateMarginLeft = 0
			formTemplateMarginRight = 0
		} else if (this.props.sideNavigationOpen) {
			formTemplateMarginLeft = 270
		}

		return (
			<div style={{ marginLeft: formTemplateMarginLeft, marginRight: formTemplateMarginRight, marginTop: 4, paddingBottom: 4, borderTop: '1px solid lightGray', boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.55), 0 6px 20px 0 rgba(0, 0, 0, 0.54)" }}>
				<PageBanner pageHeading='Migrated Alert' buttons={this.state.id ? pageButtons : null} />
				<Container fluid="true" style={{ paddingLeft: 10, paddingBottom: 20, marginTop: 10, marginLeft: 4, marginRight: 4 }}>
					<Row>
							<Col lg={6} md={6} sm={6} xs={6}>
							<Form>
								<h5 style={{ textDecoration: 'underline' }}>Alert Criteria</h5>
								<Form.Row style={{ marginLeft: -1 }}>
									<Form.Group>{alertType}</Form.Group>
								</Form.Row>
								<Form.Row>
									{
										(this.state.alertType !== 'NAME') !== true &&
										<Form.Group controlId='firstName'>
											<TextField formGroup={{ label: 'First Name', fieldType: 'text', style: {minWidth: 400}, value: this.state.firstName, primaryCriteria: false, disableField: true }} />
										</Form.Group>
									}
									{
										(this.state.alertType !== 'NAME') !== true &&
										<Form.Group controlId='lastName'>
											<TextField formGroup={{ label: 'LAST Name', fieldType: 'text', style: {minWidth: 400}, value: this.state.lastName, primaryCriteria: true, disableField: true }} />
										</Form.Group>
									}
									{
										(this.state.alertType !== 'BUSINESS') !== true &&
										<Form.Group controlId='businessName'>
											<TextField formGroup={{ label: 'Business/Trust Name', fieldType: 'text', style: {minWidth: 400}, value: this.state.businessName, primaryCriteria: true, disableField: true }}  />
										</Form.Group>
									}
									{
										(this.state.alertType !== 'PARCEL_ID') !== true &&
										<Form.Group controlId='parcelId'>
											<TextField formGroup={{ label: 'Parcel ID', fieldType: 'text', style: {minWidth: 400}, value: this.state.parcelId, primaryCriteria: true, disableField: true }} />
										</Form.Group>
									}
								</Form.Row>
								<h5 style={{ textDecoration: 'underline' }}>Alert Recipient</h5>
								<Form.Row>
										<Form.Group controlId='emailAddress'>
											<TextField formGroup={{ label: 'Email Address', fieldType: 'text', style: {minWidth: 400}, value: this.state.alertEmailAddresses && this.state.alertEmailAddresses[0] ? this.state.alertEmailAddresses[0].value : '', primaryCriteria: true, disableField: true }} />
										</Form.Group>

								</Form.Row>

									<SecondaryButton buttonLabel="Close" onClick={this.handleCancel} />&nbsp;&nbsp;

							</Form>
						</Col>
					</Row>
				</Container>
				<Alert type={this.state.alertComponentType} show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} />				
				<Loading loadingIndicator={this.state.loadingStatus === LOADING_STATUES.LOADING} />
				<Confirmation show={this.state.showDeleteConfirmationDialog} cancelConfirmation={this.hideDeleteConfirmation} proceedConfirmation={this.handleDeleteAlert} question={'Delete Alert?'} />
								
			</div>

		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertView);
